import { useQuery } from '@tanstack/react-query';
import { collection, getDocs, orderBy, query } from 'firebase/firestore';
import { firestore } from '../services/firebase';
import { queryClient } from './queryClient';

export const CATEGORIES_QUERY_KEY = ['categories'];

/**
 * Categorias com os cards de cada uma (1 leitura da coleção + 1 por categoria).
 * Como é a consulta mais pesada da tela inicial, fica em cache do react-query e
 * é pré-carregada no boot (ver `Navigation`) — antes ela só começava quando a
 * Main montava, e a lista aparecia depois do resto da página.
 */
const fetchCategoriesWithCards = async () => {
  const response = await getDocs(
    query(collection(firestore, 'categories'), orderBy('order', 'asc'))
  );

  return Promise.all(
    response.docs.map(async (catDoc) => {
      const cardsSnap = await getDocs(
        collection(firestore, 'categories', catDoc.id, 'cards')
      );
      const cards = cardsSnap.docs.map((c) => ({ id: c.id, ...c.data() }));

      return {
        id: catDoc.id,
        ...catDoc.data(),
        cards,
      };
    })
  );
};

export const useCategories = () => {
  return useQuery({
    queryKey: CATEGORIES_QUERY_KEY,
    queryFn: fetchCategoriesWithCards,
  });
};

/**
 * Recarrega a lista depois de criar/editar/arquivar conteúdo. Substitui o
 * antigo `findAllCategories()` passado como `onRefreshCategories`; devolve a
 * promise do refetch, então continua podendo ser aguardado.
 */
export const refreshCategories = () =>
  queryClient.invalidateQueries({ queryKey: CATEGORIES_QUERY_KEY });
